var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNftholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 230,
    viewBox: "0 0 174 230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 173.093,
    height: 230,
    fill: "url(#paint0_linear_0_1)",
    fillOpacity: 0.9
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.6486 134.607H71.2203V128.957C71.2203 125.301 71.94 122.2 73.3794 119.651C74.8188 117.103 76.8118 114.943 79.3584 113.171C81.905 111.398 84.8392 109.792 88.1608 108.351L99.9528 103.532C104.492 101.538 107.869 99.5995 110.084 97.7162C112.409 95.7221 113.572 93.0078 113.572 89.5735C113.572 87.0255 112.907 84.8098 111.579 82.9265C110.25 80.9323 107.759 79.3814 104.105 78.2735C100.562 77.1657 95.3578 76.6118 88.493 76.6118C77.4207 76.6118 69.7255 78.2181 65.4073 81.4309C61.1999 84.6436 59.0962 89.4627 59.0962 95.8882V101.206H39V97.2176C39 90.2382 40.7162 83.7573 44.1486 77.775C47.581 71.7926 53.0064 67.0289 60.4248 63.4838C67.954 59.8279 77.7529 58 89.8217 58C100.34 58 108.811 59.3848 115.233 62.1544C121.765 64.924 126.526 68.6353 129.516 73.2882C132.505 77.9412 134 83.0926 134 88.7426C134 94.2819 132.837 98.8794 130.512 102.535C128.298 106.08 125.419 109.016 121.876 111.343C118.443 113.669 114.845 115.608 111.08 117.159L98.9563 122.144C95.9668 123.363 93.9738 124.692 92.9773 126.132C92.0915 127.462 91.6486 129.29 91.6486 131.616V134.607ZM93.1434 171H69.8916V145.575H93.1434V171Z",
    fill: "#112B30"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_0_1",
    x: -11,
    y: -11,
    width: 195.093,
    height: 252,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 5.97358e-8,
    y1: -10.5241,
    x2: 115.599,
    y2: 189.723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#112B30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#070E0F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNftholder);
export default __webpack_public_path__ + "static/media/nftholder.7989a53230ef0a158e274f6bf4672290.svg";
export { ForwardRef as ReactComponent };